<script>
import PhoneNumber from '~plans/PhoneNumber'
import SimOptions from '~plans/SimOptions'
import FiberPostalCode from '~plans/FiberPostalCode'
import FiberInstallation from '~plans/FiberInstallation'
import FiberOptions from '~plans/FiberOptions'
import FiberContact from '~plans/FiberContact'
import FiberContactSuccess from '~plans/FiberContactSuccess'
import Helpers from '~plugins/Helpers'
import {mapActions} from "vuex";

export default {
    props: {
        planDataFromMagento: {
            type: Object,
            default: () => undefined
        },
        traduction: {
            type: Function
        },
        optionGroupToUpdate: {
            type: String,
            default: ''
        },
    },
    components: {
        PhoneNumber,
        SimOptions,
        FiberPostalCode,
        FiberInstallation,
        FiberOptions,
        FiberContact,
        FiberContactSuccess
    },
    computed: {
        $t() {
            return this.traduction
        },
        isDev() {
            return Helpers.isDev()
        },
        getSamIdName() {
            if(this.planDataFromMagento.locale === 'en'){
                return this.samIdOffer.name.replace("Fibre", "Fiber")
            }
            return this.samIdOffer.name
        },
        collaspePhoneNumber() {
            if (this.jsonData.plan.categorization === 'homebox') {
                return this.jsonData.plan.custom_options.sim_type.label
            } else {
                if (this.jsonData
                    && this.jsonData.plan
                    && this.jsonData.plan.custom_options
                    && this.jsonData.plan.custom_options.portabilite) {
                    return this.jsonData.plan.custom_options.portabilite.label
                } else {
                    return 'Votre numéro'
                }
            }

        },

        checkCurrentStep() {
            if (this.step === 1) {
                Helpers.pushDataLayer({
                    'event': 'configurator_field',
                    'step': 'phone_number'
                });
                return this.step;
            } else {
                Helpers.pushDataLayer({
                    'event': 'configurator_field',
                    'step': 'sim_type'
                });
                return this.step;
            }
        },

        collapseSimCard() {
            if (this.jsonData.plan.categorization === 'homebox') {
                return this.jsonData.plan.custom_options.modem.label
            } else {
                if (this.jsonData
                    && this.jsonData.plan
                    && this.jsonData.plan.custom_options
                    && this.jsonData.plan.custom_options.sim_type) {
                    return this.jsonData.plan.custom_options.sim_type.label
                } else {
                    console.log('Type de SIM');
                    return 'Type de SIM'
                }
            }
        }
    },
    data() {
        return {
            localData: {
                collaspePhoneNumber: 'Mon numéro de téléphone',
                collapseSimCard: 'Ma carte SIM'
            },
            planData: {
                phoneNumber: {},
                sim: {},
                options: {}
            },
            jsonData: undefined,
            step: 1,
            additionalStep: 1,
            isFirstStepFilled: false,
            isSecondStepFilled: false,
            displayModify: false,
            phoneNumberDataFromCart: null,
            simDataFromCart: null,
            simOptionID: '',
            isForfait: false,
            ifFibre: false,
            stepperItems: [],
            eligibilityStatus: null,
            contactSendSuccess: false,
            samIdOffer: null,
            fiberInstallationStep: false,
        }
    },
    async beforeMount() {

        if (this.isDev) {
            const data = await import('~data/data-dev-plans.js')
            this.jsonData = data.default
        } else {
            this.jsonData = this.planDataFromMagento
        }
    //     this.jsonData = {
    // "plan": {
    //     "plan_sku": "WIN_24",
    //     "name": "100% Win",
    //     "custom_options": {
    //         "portability_number": {
    //             "option_id": "13097",
    //             "label": "Current number",
    //             "option_identifier": "portability_number",
    //             "option_group": "portability",
    //             "option_type": "field"
    //         },
    //         "portability_operator": {
    //             "option_id": "13103",
    //             "label": "Current provider",
    //             "option_identifier": "portability_operator",
    //             "option_group": "portability",
    //             "option_type": "drop_down",
    //             "options": [
    //                 {
    //                     "option_id": "13103",
    //                     "option_type_id": "50549",
    //                     "sku": "",
    //                     "name": "Post"
    //                 },
    //                 {
    //                     "option_id": "13103",
    //                     "option_type_id": "50552",
    //                     "sku": "",
    //                     "name": "Tango"
    //                 },
    //                 {
    //                     "option_id": "13103",
    //                     "option_type_id": "50555",
    //                     "sku": "",
    //                     "name": "Luxembourg Online"
    //                 },
    //                 {
    //                     "option_id": "13103",
    //                     "option_type_id": "50558",
    //                     "sku": "",
    //                     "name": "Eltrona"
    //                 },
    //                 {
    //                     "option_id": "13103",
    //                     "option_type_id": "50561",
    //                     "sku": "",
    //                     "name": "Telkea"
    //                 },
    //                 {
    //                     "option_id": "13103",
    //                     "option_type_id": "52179",
    //                     "sku": "",
    //                     "name": "Orange Luxembourg"
    //                 }
    //             ]
    //         },
    //         "portability_sim": {
    //             "option_id": "13100",
    //             "label": "Current SIM number (ICCID)",
    //             "option_identifier": "portability_sim",
    //             "option_group": "portability",
    //             "option_type": "field"
    //         },
    //         "sim_type": {
    //             "option_id": "13106",
    //             "label": "SIM type",
    //             "option_identifier": "sim_type",
    //             "option_group": "sim",
    //             "option_type": "radio",
    //             "options": [
    //                 {
    //                     "option_id": "13106",
    //                     "option_type_id": "50564",
    //                     "sku": "OfferSIMCardPostpaid",
    //                     "name": "Standard SIM"
    //                 },
    //                 {
    //                     "option_id": "13106",
    //                     "option_type_id": "52693",
    //                     "sku": "OfferESIMCardPostpaid",
    //                     "name": "eSIM"
    //                 }
    //             ]
    //         },
    //         "portability_date": {
    //             "option_id": "13094",
    //             "label": "Transfer date",
    //             "option_identifier": "portability_date",
    //             "option_group": "portability",
    //             "option_type": "field"
    //         },
    //         "portabilite": {
    //             "option_id": "13109",
    //             "label": "Your number",
    //             "option_identifier": "portabilite",
    //             "option_group": "portability",
    //             "option_type": "radio",
    //             "options": [
    //                 {
    //                     "option_id": "13109",
    //                     "option_type_id": "50570",
    //                     "sku": "",
    //                     "name": "Get a new number"
    //                 },
    //                 {
    //                     "option_id": "13109",
    //                     "option_type_id": "50573",
    //                     "sku": "PortabiliteNumero",
    //                     "name": "Keep my current number"
    //                 }
    //             ]
    //         }
    //     },
    //     "sticky_prices": {
    //         "monthly_price": "€15.99",
    //         "phone_monthly_price": 0,
    //         "plan_monthly_price": 15.99,
    //         "price": "€5",
    //         "plan_promo_subscription_discount": null,
    //         "plan_promo_price_with_discount": "",
    //         "plan_promo_price_with_discount_formatted": "",
    //         "plan_promo_subscription_duration": null,
    //         "old_price_plan": "€15.99",
    //         "timezone_config": false,
    //         "device_plan_engagement_duration": 0,
    //         "instalment_amount": 0,
    //         "instalment_duration": 0
    //     },
    //     "linked_items": [],
    //     "categorization": "fibre",
    //     "esim_blocks": {
    //         "esim_popin_sim_only": {
    //             "title": "If you're not sure about the compatibility of your phone, please choose a standard SIM.",
    //             "content": "<div data-content-type=\"row\" data-appearance=\"default\" data-element=\"main\"><div data-content-type=\"text\" data-appearance=\"default\" data-element=\"main\" data-pb-style=\"647EC6D80909C\"><p><strong><span id=\"J7JTJ1J\" data-sheets-value=\"{&quot;1&quot;:2,&quot;2&quot;:&quot;What's an eSIM?&quot;}\" data-sheets-userformat='{\"2\":17201,\"3\":{\"1\":0},\"7\":{\"1\":[{\"1\":2,\"2\":0,\"5\":[null,2,0]},{\"1\":0,\"2\":0,\"3\":3},{\"1\":1,\"2\":0,\"4\":1}]},\"8\":{\"1\":[{\"1\":2,\"2\":0,\"5\":[null,2,0]},{\"1\":0,\"2\":0,\"3\":3},{\"1\":1,\"2\":0,\"4\":1}]},\"11\":4,\"12\":0,\"17\":1}' data-pb-style=\"647EC6D8090B6\">What's an eSIM?</span></strong></p>\r\n<ul><li id=\"U19XPRJ\"><span data-sheets-value=\"{&quot;1&quot;:2,&quot;2&quot;:&quot;&bull; It's a SIM card that's directly built into select smartphones. With one of those smartphones, it is no longer necessary to insert a physical SIM card.\\n&bull; eSIM-enabled smartphones also have a standard SIM slot. You can have an eSIM and a standard SIM in the same device and use two subscriptions at the same time.&quot;}\" data-sheets-userformat='{\"2\":817,\"3\":{\"1\":0},\"7\":{\"1\":[{\"1\":2,\"2\":0,\"5\":[null,2,0]},{\"1\":0,\"2\":0,\"3\":3},{\"1\":1,\"2\":0,\"4\":1}]},\"8\":{\"1\":[{\"1\":2,\"2\":0,\"5\":[null,2,0]},{\"1\":0,\"2\":0,\"3\":3},{\"1\":1,\"2\":0,\"4\":1}]},\"11\":4,\"12\":0}'>It's a SIM card that's directly built into select smartphones. With one of those smartphones, it is no longer necessary to insert a physical SIM card</span></li>\r\n<li><span data-sheets-value=\"{&quot;1&quot;:2,&quot;2&quot;:&quot;&bull; It's a SIM card that's directly built into select smartphones. With one of those smartphones, it is no longer necessary to insert a physical SIM card.\\n&bull; eSIM-enabled smartphones also have a standard SIM slot. You can have an eSIM and a standard SIM in the same device and use two subscriptions at the same time.&quot;}\" data-sheets-userformat='{\"2\":817,\"3\":{\"1\":0},\"7\":{\"1\":[{\"1\":2,\"2\":0,\"5\":[null,2,0]},{\"1\":0,\"2\":0,\"3\":3},{\"1\":1,\"2\":0,\"4\":1}]},\"8\":{\"1\":[{\"1\":2,\"2\":0,\"5\":[null,2,0]},{\"1\":0,\"2\":0,\"3\":3},{\"1\":1,\"2\":0,\"4\":1}]},\"11\":4,\"12\":0}'>eSIM-enabled smartphones also have a standard SIM slot. You can have an eSIM and a standard SIM in the same device and use two subscriptions at the same time</span></li>\r\n</ul><p><strong><span data-pb-style=\"647EC6D8090C9\">How does it works?</span></strong></p>\r\n<ul><li><span data-sheets-value='{\"1\":2,\"2\":\"&bull; Orange will provide you with a QR code. Scan it with your phone to associate your number with your phone.\\n&bull; Once the eSIM is activated, your phone works just like it would with a standard SIM.\"}' data-sheets-userformat='{\"2\":817,\"3\":{\"1\":0},\"7\":{\"1\":[{\"1\":2,\"2\":0,\"5\":[null,2,0]},{\"1\":0,\"2\":0,\"3\":3},{\"1\":1,\"2\":0,\"4\":1}]},\"8\":{\"1\":[{\"1\":2,\"2\":0,\"5\":[null,2,0]},{\"1\":0,\"2\":0,\"3\":3},{\"1\":1,\"2\":0,\"4\":1}]},\"11\":4,\"12\":0}'>Orange will provide you with a QR code. Scan it with your phone to associate your number with your phone</span></li>\r\n<li>\r\n<p><span data-sheets-value='{\"1\":2,\"2\":\"&bull; Orange will provide you with a QR code. Scan it with your phone to associate your number with your phone.\\n&bull; Once the eSIM is activated, your phone works just like it would with a standard SIM.\"}' data-sheets-userformat='{\"2\":817,\"3\":{\"1\":0},\"7\":{\"1\":[{\"1\":2,\"2\":0,\"5\":[null,2,0]},{\"1\":0,\"2\":0,\"3\":3},{\"1\":1,\"2\":0,\"4\":1}]},\"8\":{\"1\":[{\"1\":2,\"2\":0,\"5\":[null,2,0]},{\"1\":0,\"2\":0,\"3\":3},{\"1\":1,\"2\":0,\"4\":1}]},\"11\":4,\"12\":0}'>Once the eSIM is activated, your phone works just like it would with a standard SIM</span></p>\r\n</li>\r\n</ul><p><strong><span data-sheets-value='{\"1\":2,\"2\":\"Compatible smartphones\"}' data-sheets-userformat='{\"2\":17201,\"3\":{\"1\":0},\"7\":{\"1\":[{\"1\":2,\"2\":0,\"5\":[null,2,0]},{\"1\":0,\"2\":0,\"3\":3},{\"1\":1,\"2\":0,\"4\":1}]},\"8\":{\"1\":[{\"1\":2,\"2\":0,\"5\":[null,2,0]},{\"1\":0,\"2\":0,\"3\":3},{\"1\":1,\"2\":0,\"4\":1}]},\"11\":4,\"12\":0,\"17\":1}' data-pb-style=\"647EC6D8090D8\">Compatible smartphones</span></strong></p>\r\n<p><strong>Apple</strong></p>\r\n<ul><li>\r\n<p>iPhone (under iOS 12.1 or later)</p>\r\n</li>\r\n<li>\r\n<p>iPhone XS, XS Max, XR</p>\r\n</li>\r\n<li>\r\n<p>iPhone 11, 11 Pro, 11 Pro Max</p>\r\n</li>\r\n<li>\r\n<p>iPhone 12, 12 Max, 12 Pro, 12 Pro Max</p>\r\n</li>\r\n</ul><p><strong>Samsung</strong></p>\r\n<ul><li>\r\n<p>Galaxy S20, S20+, S20 Ultra</p>\r\n</li>\r\n<li>\r\n<p>Galaxy Z Flip.</p>\r\n</li>\r\n</ul><p><strong>Other</strong></p>\r\n<ul><li>\r\n<p>Google Pixel 3 and 4 (not sold by Orange Luxembourg but compatible if you buy them abroad).</p>\r\n</li>\r\n</ul></div></div><style>#html-body [data-pb-style=\"647EC6D80909C\"]{border-style: none; border-width: 1px; border-radius: 0px; margin: 0px; padding: 0px;}#html-body [data-pb-style=\"647EC6D8090B6\"]{color: #000000; font-size: 18px; font-family: Arial;}#html-body [data-pb-style=\"647EC6D8090C9\"]{font-size: 18px;}#html-body [data-pb-style=\"647EC6D8090D8\"]{font-size: 18px;}</style>"
    //         },
    //         "esim_popin_phone": {
    //             "title": "If you prefer to receive a standard SIM card, you can choose to.",
    //             "content": "<div data-content-type=\"row\" data-appearance=\"default\" data-element=\"main\"><div data-content-type=\"text\" data-appearance=\"default\" data-element=\"main\" data-pb-style=\"647EC6D809F67\"><p id=\"NSVDJSD\"><strong><span data-pb-style=\"647EC6D809F7B\">What's an eSIM?</span></strong></p>\r\n<ul><li><span data-sheets-value=\"{&quot;1&quot;:2,&quot;2&quot;:&quot;&bull; It's a SIM card that's directly built into select smartphones. With one of those smartphones, it is no longer necessary to insert a physical SIM card.\\n&bull; eSIM-enabled smartphones also have a standard SIM slot. You can have an eSIM and a standard SIM in the same device and use two subscriptions at the same time.&quot;}\" data-sheets-userformat='{\"2\":817,\"3\":{\"1\":0},\"7\":{\"1\":[{\"1\":2,\"2\":0,\"5\":[null,2,0]},{\"1\":0,\"2\":0,\"3\":3},{\"1\":1,\"2\":0,\"4\":1}]},\"8\":{\"1\":[{\"1\":2,\"2\":0,\"5\":[null,2,0]},{\"1\":0,\"2\":0,\"3\":3},{\"1\":1,\"2\":0,\"4\":1}]},\"11\":4,\"12\":0}'> It's a SIM card that's directly built into select smartphones. With one of those smartphones, it is no longer necessary to insert a physical SIM card</span></li>\r\n<li><span data-sheets-value=\"{&quot;1&quot;:2,&quot;2&quot;:&quot;&bull; It's a SIM card that's directly built into select smartphones. With one of those smartphones, it is no longer necessary to insert a physical SIM card.\\n&bull; eSIM-enabled smartphones also have a standard SIM slot. You can have an eSIM and a standard SIM in the same device and use two subscriptions at the same time.&quot;}\" data-sheets-userformat='{\"2\":817,\"3\":{\"1\":0},\"7\":{\"1\":[{\"1\":2,\"2\":0,\"5\":[null,2,0]},{\"1\":0,\"2\":0,\"3\":3},{\"1\":1,\"2\":0,\"4\":1}]},\"8\":{\"1\":[{\"1\":2,\"2\":0,\"5\":[null,2,0]},{\"1\":0,\"2\":0,\"3\":3},{\"1\":1,\"2\":0,\"4\":1}]},\"11\":4,\"12\":0}'>eSIM-enabled smartphones also have a standard SIM slot. You can have an eSIM and a standard SIM in the same device and use two subscriptions at the same time</span></li>\r\n</ul><p><strong><span data-pb-style=\"647EC6D809F8A\">How does it works?</span></strong></p>\r\n<ul><li><span data-sheets-value='{\"1\":2,\"2\":\"&bull; Orange will provide you with a QR code. Scan it with your phone to associate your number with your phone.\\n&bull; Once the eSIM is activated, your phone works just like it would with a standard SIM.\"}' data-sheets-userformat='{\"2\":2873,\"3\":{\"1\":0},\"6\":{\"1\":[{\"1\":2,\"2\":0,\"5\":[null,2,0]},{\"1\":0,\"2\":0,\"3\":3},{\"1\":1,\"2\":0,\"4\":1}]},\"7\":{\"1\":[{\"1\":2,\"2\":0,\"5\":[null,2,0]},{\"1\":0,\"2\":0,\"3\":3},{\"1\":1,\"2\":0,\"4\":1}]},\"8\":{\"1\":[{\"1\":2,\"2\":0,\"5\":[null,2,0]},{\"1\":0,\"2\":0,\"3\":3},{\"1\":1,\"2\":0,\"4\":1}]},\"11\":4,\"12\":0,\"14\":[null,2,0]}'> Orange will provide you with a QR code. Scan it with your phone to associate your number with your phone.</span></li>\r\n<li><span data-sheets-value='{\"1\":2,\"2\":\"&bull; Orange will provide you with a QR code. Scan it with your phone to associate your number with your phone.\\n&bull; Once the eSIM is activated, your phone works just like it would with a standard SIM.\"}' data-sheets-userformat='{\"2\":2873,\"3\":{\"1\":0},\"6\":{\"1\":[{\"1\":2,\"2\":0,\"5\":[null,2,0]},{\"1\":0,\"2\":0,\"3\":3},{\"1\":1,\"2\":0,\"4\":1}]},\"7\":{\"1\":[{\"1\":2,\"2\":0,\"5\":[null,2,0]},{\"1\":0,\"2\":0,\"3\":3},{\"1\":1,\"2\":0,\"4\":1}]},\"8\":{\"1\":[{\"1\":2,\"2\":0,\"5\":[null,2,0]},{\"1\":0,\"2\":0,\"3\":3},{\"1\":1,\"2\":0,\"4\":1}]},\"11\":4,\"12\":0,\"14\":[null,2,0]}'>Once the eSIM is activated, your phone works just like it would with a standard SIM.</span></li>\r\n</ul></div></div><style>#html-body [data-pb-style=\"647EC6D809F67\"]{border-style: none; border-width: 1px; border-radius: 0px; margin: 0px; padding: 0px;}#html-body [data-pb-style=\"647EC6D809F7B\"]{font-size: 18px;}#html-body [data-pb-style=\"647EC6D809F8A\"]{font-size: 18px;}</style>"
    //         }
    //     },
    //     "iccid_block": {
    //         "title": "The ICCID number is composed of 19 digits. Here's how to find it.",
    //         "content": "<div data-content-type=\"row\" data-appearance=\"default\" data-element=\"main\"><div data-content-type=\"text\" data-appearance=\"default\" data-element=\"main\" data-pb-style=\"647EC6D80AE6B\"><p><span data-pb-style=\"647EC6D80AE7F\"><strong><span data-pb-style=\"647EC6D80AE8F\">iPhone</span></strong></span></p>\r\n<ol><li><span data-sheets-value='{\"1\":2,\"2\":\"iPhone\"}' data-sheets-userformat='{\"2\":17201,\"3\":{\"1\":0},\"7\":{\"1\":[{\"1\":2,\"2\":0,\"5\":[null,2,0]},{\"1\":0,\"2\":0,\"3\":3},{\"1\":1,\"2\":0,\"4\":1}]},\"8\":{\"1\":[{\"1\":2,\"2\":0,\"5\":[null,2,0]},{\"1\":0,\"2\":0,\"3\":3},{\"1\":1,\"2\":0,\"4\":1}]},\"11\":4,\"12\":0,\"17\":1}'>Open the Settings app</span></li>\r\n<li><span data-sheets-value='{\"1\":2,\"2\":\"iPhone\"}' data-sheets-userformat='{\"2\":17201,\"3\":{\"1\":0},\"7\":{\"1\":[{\"1\":2,\"2\":0,\"5\":[null,2,0]},{\"1\":0,\"2\":0,\"3\":3},{\"1\":1,\"2\":0,\"4\":1}]},\"8\":{\"1\":[{\"1\":2,\"2\":0,\"5\":[null,2,0]},{\"1\":0,\"2\":0,\"3\":3},{\"1\":1,\"2\":0,\"4\":1}]},\"11\":4,\"12\":0,\"17\":1}'>Go to General &gt; About. The ICCID is located at the bottom of the page</span></li>\r\n<li><span data-sheets-value='{\"1\":2,\"2\":\"iPhone\"}' data-sheets-userformat='{\"2\":17201,\"3\":{\"1\":0},\"7\":{\"1\":[{\"1\":2,\"2\":0,\"5\":[null,2,0]},{\"1\":0,\"2\":0,\"3\":3},{\"1\":1,\"2\":0,\"4\":1}]},\"8\":{\"1\":[{\"1\":2,\"2\":0,\"5\":[null,2,0]},{\"1\":0,\"2\":0,\"3\":3},{\"1\":1,\"2\":0,\"4\":1}]},\"11\":4,\"12\":0,\"17\":1}'>Hold your finger down on the number to copy it. You can then paste it in the \"Current SIM number\" field</span></li>\r\n</ol><p><span data-pb-style=\"647EC6D80AE9D\"><strong><span data-pb-style=\"647EC6D80AEAB\">Android</span></strong></span></p>\r\n<ol><li><span data-sheets-value='{\"1\":2,\"2\":\"iPhone\"}' data-sheets-userformat='{\"2\":17201,\"3\":{\"1\":0},\"7\":{\"1\":[{\"1\":2,\"2\":0,\"5\":[null,2,0]},{\"1\":0,\"2\":0,\"3\":3},{\"1\":1,\"2\":0,\"4\":1}]},\"8\":{\"1\":[{\"1\":2,\"2\":0,\"5\":[null,2,0]},{\"1\":0,\"2\":0,\"3\":3},{\"1\":1,\"2\":0,\"4\":1}]},\"11\":4,\"12\":0,\"17\":1}'>Open the Settings app on your phone</span></li>\r\n<li><span data-sheets-value='{\"1\":2,\"2\":\"iPhone\"}' data-sheets-userformat='{\"2\":17201,\"3\":{\"1\":0},\"7\":{\"1\":[{\"1\":2,\"2\":0,\"5\":[null,2,0]},{\"1\":0,\"2\":0,\"3\":3},{\"1\":1,\"2\":0,\"4\":1}]},\"8\":{\"1\":[{\"1\":2,\"2\":0,\"5\":[null,2,0]},{\"1\":0,\"2\":0,\"3\":3},{\"1\":1,\"2\":0,\"4\":1}]},\"11\":4,\"12\":0,\"17\":1}'>&nbsp;Go to \"About\" or \"Information\" depending on your phone, then \"Status\"</span></li>\r\n<li><span data-sheets-value='{\"1\":2,\"2\":\"iPhone\"}' data-sheets-userformat='{\"2\":17201,\"3\":{\"1\":0},\"7\":{\"1\":[{\"1\":2,\"2\":0,\"5\":[null,2,0]},{\"1\":0,\"2\":0,\"3\":3},{\"1\":1,\"2\":0,\"4\":1}]},\"8\":{\"1\":[{\"1\":2,\"2\":0,\"5\":[null,2,0]},{\"1\":0,\"2\":0,\"3\":3},{\"1\":1,\"2\":0,\"4\":1}]},\"11\":4,\"12\":0,\"17\":1}'>Choose \"IMEI Information\"</span></li>\r\n<li><span data-sheets-value='{\"1\":2,\"2\":\"iPhone\"}' data-sheets-userformat='{\"2\":17201,\"3\":{\"1\":0},\"7\":{\"1\":[{\"1\":2,\"2\":0,\"5\":[null,2,0]},{\"1\":0,\"2\":0,\"3\":3},{\"1\":1,\"2\":0,\"4\":1}]},\"8\":{\"1\":[{\"1\":2,\"2\":0,\"5\":[null,2,0]},{\"1\":0,\"2\":0,\"3\":3},{\"1\":1,\"2\":0,\"4\":1}]},\"11\":4,\"12\":0,\"17\":1}'>Your ICCID number will be displayed on the page</span></li>\r\n<li><span data-sheets-value='{\"1\":2,\"2\":\"iPhone\"}' data-sheets-userformat='{\"2\":17201,\"3\":{\"1\":0},\"7\":{\"1\":[{\"1\":2,\"2\":0,\"5\":[null,2,0]},{\"1\":0,\"2\":0,\"3\":3},{\"1\":1,\"2\":0,\"4\":1}]},\"8\":{\"1\":[{\"1\":2,\"2\":0,\"5\":[null,2,0]},{\"1\":0,\"2\":0,\"3\":3},{\"1\":1,\"2\":0,\"4\":1}]},\"11\":4,\"12\":0,\"17\":1}'>If you can't find this number, or if it's not 19 digits long, please see below</span></li>\r\n</ol><p><span data-pb-style=\"647EC6D80AEB9\"><strong>On the back of your SIM card</strong></span></p>\r\n<p><span data-sheets-value='{\"1\":2,\"2\":\"iPhone\"}' data-sheets-userformat='{\"2\":17201,\"3\":{\"1\":0},\"7\":{\"1\":[{\"1\":2,\"2\":0,\"5\":[null,2,0]},{\"1\":0,\"2\":0,\"3\":3},{\"1\":1,\"2\":0,\"4\":1}]},\"8\":{\"1\":[{\"1\":2,\"2\":0,\"5\":[null,2,0]},{\"1\":0,\"2\":0,\"3\":3},{\"1\":1,\"2\":0,\"4\":1}]},\"11\":4,\"12\":0,\"17\":1}'>You can also remove the SIM card from your phone. The 19-digit ICCID number is printed on the back of it.</span></p></div></div><style>#html-body [data-pb-style=\"647EC6D80AE6B\"]{border-style: none; border-width: 1px; border-radius: 0px; margin: 0px; padding: 0px;}#html-body [data-pb-style=\"647EC6D80AE7F\"]{color: #000000;}#html-body [data-pb-style=\"647EC6D80AE8F\"]{font-size: 18px;}#html-body [data-pb-style=\"647EC6D80AE9D\"]{color: #000000;}#html-body [data-pb-style=\"647EC6D80AEAB\"]{font-size: 18px;}#html-body [data-pb-style=\"647EC6D80AEB9\"]{font-size: 18px; color: #000000;}</style>"
    //     }
    // },
    // "cartUrl": "https://orangelucloud.dev7.colorz.fr/en/checkout/cart/",
    // "loaderUrl": "https://orangelucloud.dev7.colorz.fr/static/version1720700153/frontend/Olu/default/en_US/images/loader-2.gif",
    // "isFromDevice": null,
    // "locale": "en"
    //     }

        this.isFibre = this.jsonData.plan.categorization === 'fibre'
        this.isForfait = this.jsonData.plan.categorization === 'forfait'
        this.fiberInstallationStep = this.jsonData.fiberInstallationStep

        if(this.isForfait){
            this.stepperItems = [
                {title: `1. ${this.$t('Your number')}`, label: `${this.$t('Your number')}`, current: true},
                {title: `2. ${this.$t('SIM type')}`, label: `${this.$t('SIM type')}`, current: false}
            ]
        }
        if(this.isFibre){
            this.stepperItems = [
                {title: `1. ${this.$t('Address')}`, label: `${this.$t('Address')}`, current: true},
                {title: `2. ${this.$t('Next Step')}`, label: `${this.$t('Next Step')}`, current: false}
            ]
        }

        if (this.optionGroupToUpdate.length > 0) {
            this.displayCorrectStep()
            this.fillData()
        }
    },
    mounted() {
        if (this.optionGroupToUpdate.length > 0 && this.step > 1) {
            // if (Helpers.isMobile()) {
            //     jQuery('#collapseSimCard').collapse('toggle')
            //     jQuery('#collaspePhoneNumber').collapse('toggle')
            // }
        }
    },
    methods: {
        ...mapActions({
            setCurrentStep: 'SET_CURRENT_STEP'
        }),
        getSubmitStatus(status){
            if(status){
                this.eligibilityStatus = null
            }
            this.contactSendSuccess = status
        },
        setStep(step, stepper){
            if(stepper && step > this.step){
                return
            }
            if(!this.eligibilityStatus && step <= this.step){
                this.eligibilityStatus = null
            }
            if(step === 1) {
                if (this.planDataFromMagento.plan.categorization === "fibre") {
                    this.stepperItems = [
                    {title: `1. ${this.$t('Address')}`, label: `${this.$t('Address')}`, current: true},
                    {title: `2. ${this.$t('Next Step')}`, label: `${this.$t('Next Step')}`, current: false}]
                }
            }
            this.step = step
            this.setCurrentStep({currentStep: step})
        },
        getStatus({status, value}){
            this.samIdOffer = value
            if(!!value){
                document.cookie = "samIdOffer=" + JSON.stringify(value) + "; expires=Fri, 27 Dec 2199 23:59:59 GMT; path=/"
            }

            this.eligibilityStatus = status
            if(status){
                if (this.fiberInstallationStep) {
                    this.stepperItems = [
                        {title: `1. ${this.$t('Address')}`, label: `${this.$t('Address')}`, current: false},
                        {title: `2. ${this.$t('Options')}`, label: `${this.$t('Options')}`, current: true},
                        {title: `3. ${this.$t('Installation')}`, label: `${this.$t('Installation')}`, current: false}]
                } else {
                    this.stepperItems = [
                        {title: `1. ${this.$t('Address')}`, label: `${this.$t('Address')}`, current: false},
                        {title: `2. ${this.$t('Options')}`, label: `${this.$t('Options')}`, current: true}]
                }
            }
            if(!status){
                this.stepperItems = [
                {title: `1. ${this.$t('Address')}`, label: `${this.$t('Address')}`, current: true},
                {title: `2. ${this.$t('Information')}`, label: `${this.$t('Information')}`, current: false}]
                this.setStep(2)
            }
            return status
        },
        displayCorrectStep() {
            let custom_options = this.planDataFromMagento.plan.custom_options
            // If the option_group in the url is the sim option
            // we update the step to show the step the user want to modify
            for (const key in custom_options) {
                if (this.optionGroupToUpdate === custom_options[key].option_group) {
                    if (custom_options[key].option_group === 'sim') {
                        this.step = 2
                        this.simOptionID = custom_options[key].option_id
                    }
                    if (custom_options[key].option_group === 'fixe') {
                        this.eligibilityStatus = true
                        this.getStatus({status: true, value: this.getCookieValue('samIdOffer')})
                        this.step = 2
                    }
                }
            }
        },
        fillData() {
            // fiber plan don't need fillData
            if (this.planDataFromMagento.plan.categorization === "fibre") {
                return
            }

            /**
             * We take the data from magento input
             */

            const dataFromMagento = this.planDataFromMagento.plan.custom_options

            // If the step is > 1, we are in the sim_type selection
            if (this.step > 1) {
                this.isFirstStepFilled = true
                this.displayModify = true
            }

            // If we are not in step 2, we make sure simOptionID is defined
            if (!this.simOptionID) {
                this.simOptionID = dataFromMagento.sim_type.option_id
            }

            const simOptions = document.querySelectorAll(Helpers.generateNameSelector(this.simOptionID))
            const simOptionsArray = Array.from(simOptions) // transform the nodeList into an array to be able to use array type function
            const selectedOption = simOptionsArray.find((option) => option.checked)
            this.simDataFromCart = dataFromMagento.sim_type.options.find(option => option.option_type_id === selectedOption.value)

            const phoneNumber = document.querySelector(Helpers.generateNameSelector(dataFromMagento.portability_number.option_id))
            const provider = document.querySelector(Helpers.generateNameSelector(dataFromMagento.portability_operator.option_id))
            const portabilityDate = document.querySelector(Helpers.generateNameSelector(dataFromMagento.portability_date.option_id))
            const iccid = document.querySelector(Helpers.generateNameSelector(dataFromMagento.portability_sim.option_id))

            if (phoneNumber.value !== '') {
                this.phoneNumberDataFromCart = {
                    keepPhoneNumber: true,
                    phoneNumber: phoneNumber.value.substring(5), // send the number without the international prefix
                    provider: provider.value,
                    portabilityDate: portabilityDate.value,
                    iccid: iccid.value
                }

                // If the sku = PortabiliteNumero, it means the user has choosed to keep is phone number
                // we take the option_id and option_type_id to select the native checkbox of magento
                const keepPhoneNumberOptions = dataFromMagento.portabilite.options.find(option => option.sku === 'PortabiliteNumero')

                this.planData.phoneNumber = {
                    keepPhoneNumber: true,
                    phoneNumber: phoneNumber.value,
                    provider: provider.value,
                    portabilityDate: portabilityDate.value,
                    iccid: iccid.value,
                    option_id: keepPhoneNumberOptions.option_id,
                    option_type_id: keepPhoneNumberOptions.option_type_id
                }
            } else {
                // If the user is on step, we fill the phoneNumber data to avoid and error at the validatePlan function in `Plans/index.vue`
                if (this.step > 1) {
                    this.planData.phoneNumber = dataFromMagento.portabilite.options.find(option => option.sku === null || option.sku === '')
                }
            }
        },
        getCookieValue(cookieName) {
            const name = cookieName + "="
            const decodedCookie = decodeURIComponent(document.cookie)
            const cookieArray = decodedCookie.split(';')

            for (let i = 0; i < cookieArray.length; i++) {
                let cookie = cookieArray[i].trim()
                if (cookie.indexOf(name) === 0) {
                    return JSON.parse(cookie.substring(name.length, cookie.length))
                }
            }
            return null
        }
    },
}
</script>
